import {
  PbGetAvailableRestockLocationsResponse,
  PbSearchCatalogResponse
} from '@itsrever/rever-api'
import { RestockLocation } from '@/domain/restock'
import { CatalogItem } from '@/domain/catalog'

export function toRestockLocationMap(
  response: PbGetAvailableRestockLocationsResponse
): Map<string, RestockLocation[]> {
  const locations = response.item_restock_locations || []

  const restockLocations = new Map<string, RestockLocation[]>([])
  locations.forEach((location) => {
    restockLocations.set(
      location.variant_id ?? '',
      location.restock_locations?.map((restockLocation) => {
        const loc: RestockLocation = {
          id: restockLocation.location_id ?? '',
          name: restockLocation.location_name ?? '',
          isDefault: restockLocation.is_default ?? false
        }
        return loc
      }) ?? []
    )
  })
  return restockLocations
}

export function toCatalogItems(
  response: PbSearchCatalogResponse
): CatalogItem[] {
  return (response.items ?? []).map((item) => ({
    id: item.id ?? '',
    label: item.label ?? '',
    variantsCount: Number(item.variants_count ?? 0),
    productsCount: Number(item.products_count ?? 0),
    imageUrl: item.image_url ?? ''
  }))
}
